import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import defaultSettings from '@/config/defaultSettings';
import { type AppLayoutSettings, normalizeSettings } from '@/config/preferences';
import { browserStorage } from '@/utils/browserStorage';

export type { AppLayoutSettings } from '@/config/preferences';

type LayoutSettingsState = {
  settings: AppLayoutSettings;
  setSettings: (settings: AppLayoutSettings) => void;
  resetSettings: () => void;
};

export const useLayoutSettingsStore = create<LayoutSettingsState>()(
  persist(
    (set) => ({
      settings: defaultSettings,
      setSettings: (settings) =>
        set((state) => ({
          settings: normalizeSettings({
            ...defaultSettings,
            ...state.settings,
            ...settings,
          }),
        })),
      resetSettings: () => set({ settings: { ...defaultSettings } }),
    }),
    {
      name: 'react-admin.layout-settings.v1',
      storage: createJSONStorage(() => browserStorage),
      partialize: ({ settings }) => ({ settings }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<LayoutSettingsState> | undefined;
        return {
          ...currentState,
          settings: {
            ...defaultSettings,
            ...normalizeSettings(persisted?.settings ?? {}),
          },
        };
      },
    },
  ),
);
